import React from 'react';
import PropTypes from 'prop-types';
import GoogleMapsLoader from 'google-maps';
import { default as GoogleMap, Marker, InfoWindow } from 'google-maps-react'

const CENTER = { lat: 37.09024, lng: -95.712891 };

export default class MappedLocation extends React.Component {
  static propTypes = {
    googleMapsApiKey: PropTypes.string.isRequired,
    width: PropTypes.string,
    height: PropTypes.string,
    locations: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.string,
      label: PropTypes.string,
      lat: PropTypes.number.isRequired,
      lng: PropTypes.number.isRequired
    })).isRequired,
    zoom: PropTypes.number,
    getMarkerInfoContent: PropTypes.func
  };

  static defaultProps = {
    width: '300px',
    height: '300px',
    zoom: 4
  };

  constructor(props) {
    super(props);
    this.state = {
      showingInfoWindow: false,
      activeMarker: {},
      selectedPlace: {}
    };
    this.onReady = this.onReady.bind(this);
    this.centerMap = this.centerMap.bind(this);
    this.onMarkerClick = this.onMarkerClick.bind(this);
    this.onWindowHasClosed = this.onWindowHasClosed.bind(this);
  }

  componentDidMount() {
    GoogleMapsLoader.KEY = this.props.googleMapsApiKey;
    GoogleMapsLoader.VERSION = '3.34'
    GoogleMapsLoader.LIBRARIES = ['places'];
    GoogleMapsLoader.load((google) => this.setState({ google }));
  }

  componentWillReceiveProps(newProps) {
    if (this.props.locations !== newProps.locations && this.mapProps && this.map) {
      this.centerMap(this.mapProps, this.map);
    }
  }

  onReady(mapProps, map) {
    this.mapProps = mapProps;
    this.map = map;
    this.centerMap(mapProps, map);
    map.setOptions({ 'scrollwheel': false });
  }

  centerMap(mapProps, map) {
    if (this.props.locations.length > 1) {
      var bounds = new mapProps.google.maps.LatLngBounds();
      this.props.locations.map(function (location) {
        return bounds.extend(location);
      }, this);
      map.fitBounds(bounds);
    }
  }
  onMarkerClick(props, marker, e) {
    this.setState({
      selectedPlace: props,
      activeMarker: marker,
      showingInfoWindow: true
    });
  }

  onWindowHasClosed(props, marker, e) {
    this.setState({
      showingInfoWindow: false,
      activeMarker: null
    });
  }

  render() {
    let containerStyles = { position: 'relative', width: this.props.width, height: this.props.height };
    return (
      <div aria-hidden={true}>
        {this.state.google ?
          <GoogleMap google={this.state.google} onReady={this.onReady} containerStyle={containerStyles}
            initialCenter={!this.props.locations.length ? CENTER : this.props.locations[0]} zoom={this.props.zoom}>
            {this.props.locations.map(function (location, index) {
              return <Marker id={location.id} position={location} key={JSON.stringify(location) + index} onClick={this.onMarkerClick} />
            }, this)
            }
            {this.props.getMarkerInfoContent ?
              <InfoWindow marker={this.state.activeMarker} visible={this.state.showingInfoWindow} onClose={this.onWindowHasClosed}>
                <div>{this.props.getMarkerInfoContent(this.state.selectedPlace)}</div>
              </InfoWindow> : <div />}
          </GoogleMap>
          : null}
      </div>
    );
  }
}
